import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import Link from 'components/shared/link';
import MENU_ICONS from 'constants/menu-icons';
import MainContext from 'context/main';
import translations from 'i18n';

const DropdownLink = ({ id, label, path, iconName, description, activeDropdownLabel }) => {
  const { language } = useContext(MainContext);
  const locale = language?.locale || 'en';

  const Icon = MENU_ICONS[iconName] ?? null;

  return (
    <Link
      className={clsx(
        'grid item-center gap-x-[9px] font-medium !font-sans !text-[#454d54] hover:!text-new-black',
        {
          'grid-cols-[36px_1fr]': activeDropdownLabel === translations[locale].mainMenu.features,
          'grid-cols-[16px_1fr]': activeDropdownLabel !== translations[locale].mainMenu.features,
          'gap-y-1': activeDropdownLabel === translations[locale].mainMenu.resources,
        }
      )}
      to={path}
      theme="black"
      size="sm"
      id={id}
    >
      {Icon &&
        (activeDropdownLabel === translations[locale].mainMenu.features ? (
          <div className="row-span-2 flex justify-center items-center size-9 rounded bg-secondary-2/[0.08]">
            <Icon className="size-5 text-secondary-2 transition-colors duration-300 group-hover:text-blue-hover" />
          </div>
        ) : (
          <Icon className="size-4 flex-shrink-0 text-secondary-2 transition-colors duration-300 group-hover:text-blue-hover" />
        ))}
      <p
        className={clsx({
          'pt-0.5': activeDropdownLabel !== translations[locale].mainMenu.resources,
        })}
      >
        {label}
      </p>
      {description && (
        <p className="col-start-2 font-normal text-sm leading-denser text-gray-8 transition-colors duration-300 group-hover:text-[#454f59]">
          {description}
        </p>
      )}
    </Link>
  );
};

DropdownLink.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  description: PropTypes.string,
  activeDropdownLabel: PropTypes.string.isRequired,
};

DropdownLink.defaultProps = {
  iconName: null,
  description: null,
};

export default DropdownLink;
